import React, { useState, useEffect, useRef, useContext } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import IconButton from '@mui/material/IconButton';
import VisibilityIcon from '@mui/icons-material/Visibility';
import ModeEditOutlineOutlinedIcon from '@mui/icons-material/ModeEditOutlineOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import DetailsPageCard from '../../common/DetailsPage/DetailsPageCard';
import CustomModal from '../../../components/common/CustomModal';
import CreatePackingList from '../CreateForm/CreatePackingList';
import UpdatePackingList from '../UpdateForm/UpdatePackingList';
import MessageBox from '../../common/CustomMessageBox';
import CustomDelete from '../../common/CustomDeleteAlert';
import { useExportShipmentDetails } from './Hook/useExportShipmentDetails';
import { DELETE_PACKING_LIST_EXPORT, LIST_COMMERCIAL_INVOICES_EXPORT, LIST_PACKING_LISTS_EXPORT, LIST_SALES_CONTRACTS_EXPORT } from '../../../services/apiRoutes';
import { genericPost } from '../../../services/authServices';
import PackingListView from '../ViewDetails/PackingListView';
import CustomLoader from '../../common/CustomLoader';
import { AuthContext } from '../../../context/AuthContext';
import InventoryOutlinedIcon from '@mui/icons-material/InventoryOutlined';
import axios from 'axios';
import { useCompanyDateFormat } from "../../../constants/useCompanyDateFormat";
import { getPortMasters } from '../../../services/CommonServices';


const PackingList = ({ fetchButtonList }) => {
    const { token } = useContext(AuthContext)
    const companyDateFormat = useCompanyDateFormat();
    const [portMasters, setPortMasters] = useState([]);
    const [open, setOpen] = useState(true);
    const [modal, setModal] = useState(false);
    const [updateModal, setUpdateModal] = useState(false);
    const [activeTab, setActiveTab] = useState('Packing List');
    const [data, setData] = useState([]);
    const [invoiceList, setInvoiceList] = useState([]);
    const [saleContractList, setSaleContractList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [message, setMessage] = useState({ open: false, text: '', type: '' });
    const [packingListId, setPackingListId] = useState('');
    const [viewModal, setViewModal] = useState(false);
    const navigate = useNavigate();
    const { exportShipmentId } = useParams();
    const { shipmentDetails, loading: shipmentLoading } = useExportShipmentDetails(exportShipmentId);
    const [newShippingId, setNewShippingId] = useState(null);
    const [deleteAlert, setDeleteAlert] = useState(false)
    const [rowId, setRowId] = useState('')

    let customerId, cifFob;
    const hasFetched = useRef(false);
    useEffect(() => {
        if (shipmentDetails) {
            customerId = shipmentDetails.customerId;

            cifFob = shipmentDetails.cifFob.cifFobName;
            fetchData();
            fetchDataCommercialInvoiceList();
            fetchDataSalesContract();
            getCommonData();
            hasFetched.current = true;
        }
    }, [shipmentDetails, updateModal, packingListId, token, deleteAlert, modal]);
    const getCommonData = async () => {
        const getPortMastersData = await getPortMasters()
        setPortMasters(getPortMastersData)
    }


    const fetchDataCommercialInvoiceList = async () => {
        try {
            const payload = {
                customerNamesId: customerId,
                shipmentId: shipmentId,
            };
            const response = await genericPost(LIST_COMMERCIAL_INVOICES_EXPORT, payload, {
            });
            if (response.data && response.data.success && response.data.data) {
                const customersData = response.data.data.map((customer) => ({
                    id: customer.commercialInvExpId,
                    title: customer.commercialInvoiceNo,
                }));
                setInvoiceList(customersData);
            } else {
                return [];
            }
        } catch (error) {
            console.error('Error fetching customer list:', error);
            return [];
        }
    };
    const fetchDataSalesContract = async () => {
        try {
            const payload = {
                customerNamesId: customerId,
                shipmentId: shipmentId,
            };
            const response = await genericPost(LIST_SALES_CONTRACTS_EXPORT, payload, {
            });
            if (response.data && response.data.success && response.data.data) {
                const customersData = response.data.data.map((customer) => ({
                    id: customer.salesContractId,
                    title: customer.salesContractNo,
                }));
                setSaleContractList(customersData);
            } else {
                return [];
            }
        } catch (error) {
            console.error('Error fetching customer list:', error);
            return [];
        }
    };


    const fetchData = async () => {
        setLoading(true);
        try {
            const payload = {
                clientCompanyId: customerId,
                shipmentId: shipmentId,
            };

            const response = await genericPost(LIST_PACKING_LISTS_EXPORT, payload);
            if (response.data.success) {
                const packingLists = response.data.data.map((item, index) => ({
                    packingListId: item.packingListId || '',
                    index: (index + 1).toString().padStart(2, '0'),
                    userId: item.userId || '',
                    companyId: item.companyId || '',
                    clientCompanyId: item.clientCompanyId || '',
                    addressTo: item.addressTo || '',
                    invNo: item?.commercialInv?.commercialInvoiceNo || '',
                    salesContractNo: item?.SalesContract?.salesContractNo || '',
                    date: companyDateFormat(item?.date) || '',
                    loadingPort: item.loadingPort || '',
                    destinationPort: item.destinationPort || '',
                    mark: item.mark || '',
                    description: item.description || '',
                    quantity: item.quantity || '',
                    pkg: item.pkg || '',
                    netWeight: item.nw || '',
                    tareWeight: item.tw || '',
                    measurement: item.measurement || '',
                    totalPackedIn: item.totalPackedIn || '',
                    totalGrossWeight: item.totalGrossWeight || '',
                    totalNetWeight: item.totalNetWeight || '',
                    casNo: item.casNo || '',
                    iupac: item.iupac || '',
                    createdAt: item.createdAt || '',
                    updatedAt: item.updatedAt || '',
                    customerName: item.customer?.clientCompanyName || '',
                    customerCountry: item.customer?.mailingCountry?.name || '',
                    shipmentId: item.shipmentId || '',
                }));
                const { newShippingId } = response.data;
                setNewShippingId(newShippingId);
                setData(packingLists);
            } else {
                setError('No packing list data found');
            }
        } catch (error) {
            setError('Error fetching packing list data');
            console.error('Error fetching packing list data', error);
        } finally {
            setLoading(false);
        }
    };
    const handleDelete = async (packingListId) => {
        setLoading(true);
        const authToken = sessionStorage.getItem('accessToken');

        try {
            const response = await axios.delete(DELETE_PACKING_LIST_EXPORT(packingListId), {
                headers: {
                    Authorization: `Bearer ${authToken}`,
                },
            });

            if (response.status === 200) {
                setDeleteAlert(false);
                setMessage({
                    open: true,
                    text: "deleted successfully",
                    type: "success",
                });
                fetchData();
                fetchButtonList();
            } else {
                setLoading(false);
            }
        } catch (error) {
            setLoading(false);

            if (error.response) {
                if (error.response.status === 409) {
                    setMessage({
                        open: true,
                        text: error.response.data?.error || "Cannot delete Data. Related Shipment exists.",
                        type: "error",
                    });
                } else {
                    setMessage({
                        open: true,
                        text: "An error occurred while deleting the Data.",
                        type: "error",
                    });
                }
            } else {
                console.error("Error deleting Data", error);
                setMessage({
                    open: true,
                    text: "Network error. Please try again later.",
                    type: "error",
                });
            }
        }
    };


    // Table columns
    const columns = [
        {
            accessor: 'index', label: 'SN', id: 'index', styleAccessor: {
                textAlign: 'center', maxWidth: '200px', width: "50px"
            },
        },
        {
            id: 'shipmentId', label: 'Shipping Id', accessor: 'shipmentId', styleAccessor: {
                textAlign: 'center',
            },
        },
        {
            id: 'invNo', label: 'Packing List No.', accessor: 'invNo', styleAccessor: {
                textAlign: 'center',
            },
        },
        {
            id: 'salesContractNo', label: 'Sales Contract No.', accessor: 'salesContractNo', styleAccessor: {
                textAlign: 'center',
            },
        },
        {
            id: 'date', label: 'Date', accessor: 'date', styleAccessor: {
                textAlign: 'center',
            },
        },
        { id: 'customerName', label: 'Customer Name', accessor: 'customerName' },
        {
            id: 'totalNetWeight', label: 'Net Weight', accessor: 'totalNetWeight', styleAccessor: {
                textAlign: 'center',
            },
        },
        {
            id: 'totalGrossWeight', label: 'Gross Weight', accessor: 'totalGrossWeight', styleAccessor: {
                textAlign: 'center',
            },
        },
        {
            id: 'measurement', label: 'Measurement', accessor: 'measurement', styleAccessor: {
                textAlign: 'center',
            },
        },
        {
            id: 'action',
            label: 'Action',
            accessor: 'action',
            Cell: ({ row }) => (
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '1px' }}>
                    <IconButton onClick={() => handleViewClick(row.packingListId)} style={{ marginRight: '1px' }}>
                        <VisibilityIcon style={{ color: '#059212' }} />
                    </IconButton>
                    <IconButton onClick={() => handleUpdateClick(row.packingListId)} style={{ marginRight: '1px' }}>
                        <ModeEditOutlineOutlinedIcon style={{ color: '#050C9C' }} />
                    </IconButton>
                    <IconButton onClick={() => handleOpenDeleteAlert(row.packingListId)}>
                        <DeleteOutlineOutlinedIcon style={{ color: '#E4003A' }} />
                    </IconButton>
                </div>
            ),
        },
    ];


    const handleUpdateClick = (id) => {
        setPackingListId(id);
        setUpdateModal(true);
    };

    const handleOpenDeleteAlert = (rowId) => {
        setDeleteAlert(true)
        setRowId(rowId)
    }


    const handleOpen = () => {
        setModal(true);
    };

    const handleClose = () => {
        setModal(false);
    };

    const handleCloseUpdate = () => {
        setUpdateModal(false);
        setPackingListId('');
    };

    const handleViewClick = (id) => {
        setPackingListId(id);
        setViewModal(true);
    };

    const handleCloseView = () => {
        setViewModal(false);
        setPackingListId('');
    };


    if (!shipmentDetails) {
        return <p>  <CustomLoader open={shipmentLoading} /> </p>;
    }

    const addressToClient = `${shipmentDetails.customer.billingStreet || ''}, ${shipmentDetails.customer.billingCity.name || ''}, ${shipmentDetails.customer.billingState.name || ''}, ${shipmentDetails.customer.billingCountry.name || ''}, ${shipmentDetails.customer.billingPincode || ''}.`.trim();
    const companyName = shipmentDetails.customer.clientCompanyName;
    const addressTo = `${companyName || ''}, ${addressToClient || ''}`.trim();
    const phoneNumber = shipmentDetails.customer.mobile;
    const customerName = shipmentDetails.customerId;
    const shipmentId = shipmentDetails.shipmentId;
    const initial = shipmentDetails.customer.clientCompanyName ? shipmentDetails.customer.clientCompanyName.charAt(0).toUpperCase() : '';
    const shipmentOrgId = shipmentDetails.exportShipmentId;
    const templateId = shipmentDetails?.company?.packingListTemplate ?? '1';
    const portOfLoading = shipmentDetails.portOfLoading ?? "";
    const portOfDestination = shipmentDetails.portOfDestination ?? "";


    // JSX Structure
    return (
        <div>
            <CustomLoader open={loading} />
            <DetailsPageCard
                Icon={InventoryOutlinedIcon}
                columns={columns}
                title="Packing List"
                buttonTitle="Create Packing List"
                handleOpen={handleOpen}
                data={data}
                loading={loading}
                error={error}
            />
            <CustomModal open={modal}  >
                <CreatePackingList
                    fetchData={fetchData}
                    customerName={customerName}
                    addressTo={addressTo}
                    phoneNumber={phoneNumber}
                    companyName={companyName}
                    shipmentId={shipmentId}
                    newShippingId={newShippingId}
                    shipmentOrgId={shipmentOrgId}
                    invoiceList={invoiceList}
                    saleContractList={saleContractList}
                    setMessage={setMessage}
                    fetchButtonList={fetchButtonList}
                    portOfLoading={portOfLoading}
                    portOfDestination={portOfDestination}
                    portMasters={portMasters}
                    handleClose={handleClose}
                />
            </CustomModal>

            <CustomModal open={updateModal}  >
                <UpdatePackingList
                    fetchData={fetchData}
                    setMessage={setMessage}
                    phoneNumber={phoneNumber}
                    companyName={companyName}
                    handleClose={handleCloseUpdate}
                    packingListId={packingListId}
                    portMasters={portMasters}
                    saleContractList={saleContractList}
                    invoiceList={invoiceList}
                />
            </CustomModal>

            <CustomModal open={viewModal} handleClose={handleCloseView}>
                <PackingListView
                    fetchData={fetchData}
                    setMessage={setMessage}
                    phoneNumber={phoneNumber}
                    companyName={companyName}
                    handleClose={handleCloseView}
                    packingListId={packingListId}
                    templateId={templateId}
                    shipmentOrgId={shipmentOrgId}
                />
            </CustomModal>

            <MessageBox
                open={message.open}
                onClose={() => setMessage({ ...message, open: false })}
                message={message.text}
                handleClose={() => setMessage({ ...message, open: false })}
                type={message.type}
            />
            <CustomDelete
                handleDelete={handleDelete}
                open={deleteAlert}
                rowId={rowId}
                handleClose={() => setDeleteAlert(false)}
            />
        </div>
    );
};

export default PackingList;
